{
  "comment": "M7 spec §2.1–§2.2 (S3 owns): the watch thread's logs. Log shape: src/story/schemas.ts evidenceLogSchema (at most ~120 words or one table; form carries the fact). Ids are unique across every evidence file; this file's ids start 'watch.'. Non-kill watch leads before tier 3: the 1st Holdfast contract docket, Kell's tally, the Harrow mast log and the two Wire leaks (spec §2.2). The guaranteed Holdfast-contract logs (W4): watch.contract_docket (1st) and watch.contract_book_page (3rd). watch.book_seven_hulls (S37, V-1): the Watch overlay, the facing page of book 7 handed over with it; its rows are generated by the story link from the player's real tetherstone sales (story-link/missions/m2.ts watchRows; the data row is the no-sale fallback). Wire leaks: watch.wire_yard_order (hidden event holdfastFundsGuardians), watch.wire_varro_quote (hidden event varroStoke). Template slots are {name} in braces, filled from the Career at runtime: {pilot}, {system}, {day} for the Reyes-named pilot (spec §2.4); {operation}, {system}, {day}, {drop} for the repeatable knowledge corroboration (a meter proof, spec §2.5). Old Tethys records call tetherstone FC-6; the Holdfast call it tetherstone. Every name, code and date is a placeholder until the naming pass (spec §15 item 7). Claim words for tier 3 (spec §2.3): weakens/steadies, tetherstone/platinum_ore, mined/shipped.",
  "logs": [
    {
      "id": "watch.contract_docket",
      "thread": "watch",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Holdfast delivery docket, Harrow post",
      "date": "CY60",
      "source": "holdfastContract",
      "body": "HOLDFAST CO-OP · DELIVERY DOCKET · run 60-114\nDeliver to: Harrow post (FR-217). Leave at the mast lock.\nDo not touch the beacon setting. It is kept.\nSigned for: A.R.",
      "table": {
        "columns": ["Item", "Qty", "For"],
        "rows": [
          ["Scrubber filters, grade 2", "40", "post"],
          ["Lamp cells, mast", "6", "beacon"],
          ["Ruled paper", "2 reams", "Book 7"],
          ["Pencils", "1 box", "Book 7"]
        ]
      },
      "words": [],
      "lead": { "systemHint": "harrow", "poiKind": "derelict" },
      "fromTier": 1
    },
    {
      "id": "watch.contract_book_page",
      "thread": "watch",
      "link": "knowledge",
      "kind": "proof",
      "weight": 1,
      "title": "Loose page, Watch book 6",
      "date": "CY59",
      "source": "holdfastContract",
      "body": "WATCH BOOK 6 · page 288 · Harrow post · loose, water-stained\nFound folded in the cargo you were paid to move.\nCandle set: 12 on the steady days, 9 to 10 on the others.",
      "table": {
        "columns": ["Day", "Gate", "Carrow shifts mined: tetherstone; platinum ore", "TH- hulls shipped out"],
        "rows": [
          ["CY59 d40", "steady", "1; 3", "4"],
          ["CY59 d41", "steady", "1; 4", "9"],
          ["CY59 d44", "weakens, held 50 min", "3; 3", "2"],
          ["CY59 d45", "weakens, held 3 h", "3; 2", "0"],
          ["CY59 d47", "steady", "1; 4", "11"],
          ["CY59 d52", "weakens, held 40 min", "2; 1", "1"]
        ]
      },
      "words": ["weakens", "tetherstone", "platinum_ore", "mined", "shipped"],
      "fromTier": 1
    },
    {
      "id": "watch.kell_tally",
      "thread": "watch",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Co-op freight tally, sent by Kell",
      "date": "CY60",
      "source": "kellComms",
      "body": "CO-OP FREIGHT TALLY · sent on the trade line by T. Kell\nNote attached: \"You asked why the gate held your load. Here's ours. Come by the habitat if you want the rest.\"",
      "table": {
        "columns": ["Day", "We shipped", "Gate", "Carrow, per the Tethys roster"],
        "rows": [
          ["CY60 d71", "filters, 2 t", "held 1 h", "tetherstone mined, 3 shifts"],
          ["CY60 d72", "med-stores, 0.4 t", "held 4 h", "tetherstone mined, 3 shifts"],
          ["CY60 d80", "filters, 2 t", "on time", "tetherstone mined, 1 shift"],
          ["CY60 d88", "nothing", "held 2 h", "tetherstone mined, 2 shifts"]
        ]
      },
      "words": ["mined", "shipped", "tetherstone"],
      "lead": { "systemHint": "descendant-capital", "poiKind": "station" },
      "fromTier": 1
    },
    {
      "id": "watch.harrow_mast_log",
      "thread": "watch",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Beacon mast maintenance log, FR-217",
      "date": "CY60",
      "source": "derelictCore",
      "body": "FR-217 · MAST 2 · MAINTENANCE · core on a hand-wired relay\nThe oldest entries are CY10. The newest are this year.\nRelief comes from the deep. Fix in the last entry.",
      "table": {
        "columns": ["Day", "Work", "Candle set (per min)", "By"],
        "rows": [
          ["CY60 d31", "lamp cell 3 replaced", "12", "A.R."],
          ["CY60 d52", "gate steadies; no change", "12", "D.P."],
          ["CY60 d77", "setting lowered", "10", "A.R."],
          ["CY60 d96", "setting lowered", "9", "A.R."],
          ["CY60 d98", "relief due, nav fix logged", "9", "D.P."]
        ]
      },
      "words": ["steadies"],
      "lead": { "systemHint": "guardian-base", "poiKind": "hidden-base" },
      "fromTier": 1
    },
    {
      "id": "watch.guardian_target_list",
      "thread": "watch",
      "link": "knowledge",
      "kind": "proof",
      "weight": 1,
      "title": "Target list, green-drive tug",
      "date": "CY60",
      "source": "guardianWreck",
      "body": "Pulled from a wrecked tug: an old First Charter frame, drive burning green, registration scraped.\nHand-ruled. The last column is in a different pencil.",
      "table": {
        "columns": ["Hull", "Where", "Tonnes it didn't lift", "Gate, next day"],
        "rows": [
          ["TH barge Calloway", "Carrow vein", "310", "on time"],
          ["TH barge Hadley's Due", "Carrow vein", "280", "on time"],
          ["lease rig, cream band", "Harrow field", "60", "on time"],
          ["(missed) TH barge Ostrander", "Carrow vein", "0", "held 6 h"]
        ]
      },
      "words": [],
      "fromTier": 1
    },
    {
      "id": "watch.guardian_tape",
      "thread": "watch",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Instrument tape, green-drive tug",
      "date": "CY60",
      "source": "guardianWreck",
      "body": "A paper tape from a home-built gauge, wound on a spool. Pencil marks along the edge.\nEvery mark says the same thing: \"read at the Candle\".\nReturn address burned into the spool: FR-217, mast 2.",
      "words": [],
      "lead": { "systemHint": "harrow", "poiKind": "derelict" },
      "fromTier": 1
    },
    {
      "id": "watch.wire_yard_order",
      "thread": "watch",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Leaked yard order (the Wire)",
      "date": "CY60",
      "source": "wireLeak",
      "body": "Posted to the Wire by an unnamed yard hand, then taken down within the hour.\nPaid from the Holdfast common account. Collected at the habitat yard by a crew who would not log a registration.",
      "table": {
        "columns": ["Line", "Work", "Credits"],
        "rows": [
          ["1", "Rebuild, First Rush tug frame, drive tuned green", "48,000"],
          ["2", "Rebuild, First Rush tug frame, drive tuned green", "48,000"],
          ["3", "Gun mounts, salvaged, fitted", "22,500"],
          ["4", "Filters and med-stores held back to pay for lines 1-3", "-11,000"]
        ]
      },
      "words": [],
      "lead": { "systemHint": "descendant-capital", "poiKind": "station" },
      "fromTier": 2
    },
    {
      "id": "watch.wire_varro_quote",
      "thread": "watch",
      "link": "none",
      "kind": "lead",
      "weight": 1,
      "title": "Leaked Varro sales quote (the Wire)",
      "date": "CY60",
      "source": "wireLeak",
      "body": "VARRO SECURITY SERVICES · QUOTES ISSUED, CARROW AREA · internal\nLeaked to the Wire. Varro declined to comment.\nNote at the foot: \"Both accounts current. Do not discuss one with the other.\"",
      "table": {
        "columns": ["Customer", "Item", "Delivery"],
        "rows": [
          ["Tethys, barge escort", "2 gunships, crewed, 30 days", "Carrow vein"],
          ["Tethys, barge escort", "PDC refits, 6 barges", "Carrow vein"],
          ["unregistered, cash", "Torpedo stock, 40", "deep relay fix, on request"]
        ]
      },
      "words": [],
      "lead": { "systemHint": "guardian-base", "poiKind": "hidden-base" },
      "fromTier": 2
    },
    {
      "id": "watch.book_seven",
      "thread": "watch",
      "link": "knowledge",
      "kind": "proof",
      "weight": 1,
      "title": "Watch book 7, page 236",
      "date": "CY60",
      "source": "missionItem",
      "body": "WATCH BOOK 7 · page 236 · Harrow post · kept by A.R.\nBook 1, page 1 begins CY10 d211.\nd114, in the margin: new barges at the vein, 3.\nCopied to your core over the hand-wired relay.",
      "table": {
        "columns": ["Day", "Candle (per min)", "Gate", "Carrow tetherstone mined (shifts)"],
        "rows": [
          ["CY60 d112", "12", "steady", "1"],
          ["CY60 d114", "12", "steady", "2"],
          ["CY60 d117", "10", "weakens, held 40 min", "3"],
          ["CY60 d119", "9", "weakens, held 9 h 20 min", "3"],
          ["CY60 d120", "10", "steadies", "2"]
        ]
      },
      "words": ["weakens", "steadies", "tetherstone", "mined"],
      "fromTier": 3
    },
    {
      "id": "watch.book_seven_hulls",
      "thread": "watch",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Watch book 7, page 237",
      "date": "CY60",
      "source": "missionItem",
      "body": "WATCH BOOK 7 · page 237 · Harrow post · kept by A.R.\nHulls seen loading at the vein. Paint and class only; we can't read plates from the mast.",
      "table": {
        "columns": ["Day", "Paint", "Hull", "Where, hours"],
        "rows": [["d118", "Tethys yellow, cream band", "lease hauler", "Carrow vein, 7 h"]]
      },
      "words": [],
      "fromTier": 3
    },
    {
      "id": "watch.birth_record",
      "thread": "watch",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Birth record, Harrow post",
      "date": "CY23",
      "source": "derelictCore",
      "body": "HARROW POST · BIRTHS · page 9\nName: Ama. Weight: 2.6 kg. Breathing on her own.\nMother: S. Reyes, Watch keeper (Book 3).\nFather: crew, Lindgate tug, lost on the d40 run.\nWitness: whoever was on the mast. Candle set 11.\nRation added: one half-share, from the mother's.\nNote in another hand: she slept through the d44 hold. First one of us who ever did.",
      "words": [],
      "fromTier": 1
    },
    {
      "id": "watch.reyes_named_pilot",
      "thread": "watch",
      "link": "none",
      "kind": "texture",
      "weight": 0,
      "title": "Undelivered message, Candle relay",
      "date": "CY60",
      "source": "yourRecords",
      "body": "CANDLE RELAY · PERSONAL · HELD FOR DELIVERY\nTo: {pilot}, green-drive tug\nFrom: his sister\n\nThe filters came. Nan wants to know if you're eating. The little one has started on the mast with me, she can read the setting already. Come back for the naming day, it's soon. Bring nothing, just come.\n\nStatus: undelivered. Hull not answering since {day}, {system}.",
      "words": [],
      "fromTier": 3,
      "template": true
    },
    {
      "id": "watch.corr_meter_reading",
      "thread": "watch",
      "link": "knowledge",
      "kind": "proof",
      "weight": 1,
      "title": "Resonance meter reading",
      "date": "CY60",
      "source": "yourRecords",
      "body": "RESONANCE METER · LOGGED READING\nOperation: {operation}, {system}\nTaken: {day}\nGate transit variance before the cut: within band.\nAfter the cut: down {drop}, lagging 9 minutes.\nReading stored to your core.",
      "words": [],
      "fromTier": 3,
      "repeatable": true,
      "template": true
    }
  ]
}
